import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

// import Button from "../../components/Button/Button";
import Input from "../../../components/Input/Input";
import Runner from "../../../components/Runner/Runner";

import * as actions from "../../../store/actions/auth";

import "../Auth.css";

class Signup extends Component {
  state = {
    formInputs: {
      firstname: {
        inputType: "input",
        inputConfig: {
          type: "text",
          placeholder: "Please enter your first name",
          required: true,
        },
        value: "",
        label: "First Name",
      },
      lastname: {
        inputType: "input",
        inputConfig: {
          type: "text",
          placeholder: "Please enter your last name",
          required: true,
        },
        value: "",
        label: "Last Name",
      },
      email: {
        inputType: "input",
        inputConfig: {
          type: "email",
          placeholder: "Please enter your email",
          required: true,
        },
        value: "",
        label: "Email",
      },
      password: {
        inputType: "input",
        inputConfig: {
          type: "password",
          placeholder: "Please enter your password",
          required: true,
        },
        value: "",
        label: "Password",
      },
      confirm_password: {
        inputType: "input",
        inputConfig: {
          type: "password",
          placeholder: "Please confirm your password",
          required: true,
        },
        value: "",
        label: "Confirm Password",
      },
    },
    loading: false,
    submitted: false,
    invalidSignup: false,
    errorMessage: "",
  };

  componentDidMount() {
    this.props.resetState();
  }

  inputChangeHandler = (event, inputId) => {
    const updatedInputs = {
      ...this.state.formInputs,
    };
    const updatedObject = {
      ...updatedInputs[inputId],
      touched: true,
    };
    updatedObject.value = event.target.value;
    updatedInputs[inputId] = updatedObject;

    let formIsValid = true;
    for (let input in updatedInputs) {
      if (!updatedInputs[input].valid) {
        formIsValid = false;
      }
    }
    this.setState({ formInputs: updatedInputs, valid: formIsValid });
  };

  checkValidSignup = () => {
    const pw = this.state.formInputs.password.value;
    const confirm_pw = this.state.formInputs.confirm_password.value;
    if (pw !== confirm_pw) {
      this.setState({
        invalidSignup: true,
        errorMessage: "Passwords do not match",
        loading: false,
      });
      return false;
    }
    if (pw.length < 8) {
      this.setState({
        invalidSignup: true,
        errorMessage: "Passwords must be at least 8 characters",
        loading: false,
      });
      return false;
    }

    return true;
  };

  submitHandler = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    if (this.checkValidSignup()) {
      const userData = {
        first: this.state.formInputs.firstname.value,
        last: this.state.formInputs.lastname.value,
        email: this.state.formInputs.email.value,
        password: this.state.formInputs.password.value,
      };
      this.props.onSignUp(userData);
    }
  };

  render() {
    const formElements = [];
    for (let key in this.state.formInputs) {
      formElements.push({
        id: key,
        config: this.state.formInputs[key],
      });
    }
    const inputs = formElements.map((el) => (
      <Input
        key={el.id}
        inputType={el.config.inputType}
        inputConfig={el.config.inputConfig}
        value={el.config.value}
        label={el.config.label}
        changed={(event) => this.inputChangeHandler(event, el.id)}
      />
    ));

    return (
      <div>
        <h2>Sign Up</h2>
        {this.props.loading ? (
          <Runner />
        ) : (
          <form onSubmit={this.submitHandler}>
            {inputs}
            <p className="error">
              {this.state.errorMessage || this.props.message}
            </p>
            <button type="submit">Create My Account</button>
          </form>
        )}
        <p>
          Already a DTC member? <NavLink to="/auth/login">Log In</NavLink>
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    isLoggedIn: state.userId !== null,
    message: state.message,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSignUp: (userData) => dispatch(actions.signup(userData)),
    resetState: () => dispatch(actions.resetState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signup);
